import React from 'react'

import AttachmentThumbnail from "../blocks/thumbnail/thumbnail"
import AttachmentButtonDownload from "../blocks/buttons/download"
import AttachmentButtonOpenNewWindow from "../blocks/buttons/open-new-window"
import AttachmentButtonPreview from "../blocks/buttons/preview"
import {AttachmentViewProps} from "../attachment-view"

// type Props = {
//     attachment  : Attachment
//     mode        : 'view-in-editor' | 'edit-in-editor' | 'notes-edit'
// }

// const debug = "AttachmentViewWithPreviewInEditor"
const debug = false

export default class AttachmentViewWithPreviewInEditor extends React.Component<AttachmentViewProps> {

    onPreviewClick = () => {
        gd.attachments.preview(this.props.attachment);
    }


    render() {

        debug && console.log(debug, "render()", this.props)

        const {attachment} = this.props

        let mode = this.props.mode
        if (attachment.renderMode) mode = attachment.renderMode // redefine


        switch (mode) {

            case "view-in-editor":
                return (
                    <div className = "ui5-attachment-with-preview-in-editor"
                         onClick   = {this.onPreviewClick}>

                        <AttachmentThumbnail size       = {1200}
                                             attachment = {attachment} />


                        <div className="overlay-details">
                            {/*<div className="file-name ui5-txt-less-important-small m-l-10 m-t-15">
                                {attachment.name}
                            </div>
                            <div className="file-size ui5-txt-not-important-tiny m-l-10 ">
                                {attachment.fileSizeFormatted}
                            </div>*/}

                            <div className="attachment-preview-actions">
                                <div className="attachment-buttons-block with-border">
                                    <AttachmentButtonDownload attachment = {attachment}/>
                                    <div className="buttons-separator"/>
                                    <AttachmentButtonOpenNewWindow attachment = {attachment}/>
                                    <div className="buttons-separator"/>
                                    <AttachmentButtonPreview attachment     = {attachment}
                                                             onPreviewClick = {this.onPreviewClick} />
                                </div>
                            </div>
                        </div>

                    </div>
                )

            case 'edit-in-editor':
            default:
                return (
                    <div className="ui5-attachment-with-preview-in-editor">
                        <AttachmentThumbnail size       = {1200}
                                             attachment = {attachment} />
                    </div>
                )

        }

    }
}
